// extracted by mini-css-extract-plugin
var _1 = "FollowPostStyle-module__following___ocNOK";
var _2 = "FollowPostStyle-module__star___rSvB0";
export { _1 as "following", _2 as "star" }
